
import Vue from 'vue'
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import IconHelper from '../../mixins/iconHelper';

@Component
export default class ICon extends Mixins(IconHelper) {
    @Prop({}) 
    color!:string;

    @Prop({}) 
    icon!:string;

    get parsedIcon(){
        const coloredIcon = this.colorIcon(this.color, this.icon);
        return coloredIcon;
    }
}


